import { Button, Modal, ModalBody, ModalContent, ModalFooter } from "@heroui/react";
import { ExternalLinkIcon } from "lucide-react";
import VerifySumsub from "../../assets/verify-sumsub.svg?react";

export function VerifiedIdModal({
  onClose,
  onVerified,
}: {
  onClose: () => void;
  onVerified: () => void;
}) {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody>
          <div className="flex flex-col gap-4 items-center pt-12">
            <VerifySumsub className="scale-80" />
            <div className="text-center space-y-2">
              <div className="font-semibold">Verify ID with Sumsub</div>
              <div className="text-[#ADC0D0] text-sm text-center">
                You need to verify your ID with sumsub, when you are done you can go back to the application and
                complete the transaction.
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button fullWidth radius="full" size="lg" color="primary" className="font-semibold" onPress={onVerified}>
            Verify <ExternalLinkIcon className="size-4" />
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
